import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const name = "loader";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

export const loaderActions = { ...slice.actions, ...extraActions };
export const loaderReducer = slice.reducer;

function createInitialState() {
  return {
    value: false,
  };
}

function createReducers() {
  return {
    setLoader,
  };

  function setLoader(state, action) {
    state.value = action.payload;
  }
}

function createExtraActions() {
  return {
    loader: loader(),
  };

  function loader() {
    return createAsyncThunk(`${name}/load`, function (arg, { dispatch }) {
      dispatch(loaderActions.setLoader(arg));
    });
  }
}
